import { Checkbox as UnionCheckbox } from '@xo-union/tk-component-switches';
import { FieldProps } from 'formik';
import React from 'react';

export interface CheckboxProps extends FieldProps {
  checked: string;
  invert?: boolean;
  enabledText?: string;
  disabledText?: string;
  labelDirection?: 'left' | 'right';
}

export const Checkbox: React.FC<CheckboxProps> = ({
  field,
  form: { setFieldValue },
  invert = false,
  enabledText = 'Yes',
  disabledText = 'No',
  labelDirection = 'right',
}) => {
  const { name, value } = field;

  let checked = value;
  if (invert) {
    checked = !value;
  }
  // @ts-ignore
  const onChange = (e): void => {
    if (invert) {
      setFieldValue(name, !e.target.checked);
      return;
    }
    setFieldValue(name, e.target.checked);
  };

  return (
    <UnionCheckbox data-testid="checkbox" checked={checked} labelDirection={labelDirection} onChange={onChange}>
      {checked ? enabledText : disabledText}
    </UnionCheckbox>
  );
};
